import { IPart } from "../../models/Part";
import LoadingPulse from "../shared/LoadingPulse";
import useShippingPolicies from "../../data/useShippingPolicies";


const CourierPill = ({ courier }: { courier: string }) => {
  if (!courier) return null;

  let color = "bg-gray-100 text-gray-800";

  switch (courier) {
    case "FedEx":
      color = "bg-purple-100 text-purple-800";
      break;
    case "Proovia":
      color = "bg-blue-100 text-blue-800";
      break;
    case "Parcelforce":
      color = "bg-yellow-100 text-yellow-800";
      break;
    case "RoyalMail":
      color = "bg-red-100 text-red-800";
      break;
    case "Other":
      color = "bg-green-100 text-green-800";
      break;
  }

  return (
    <div className={`inline-block px-2 py-1 rounded-full text-xs font-semibold mt-2 ${color}`}>
      {courier}
    </div>
  );
}

export default function ShippingPolicyCell({ part }: { part: IPart; }) {
  const { shippingPolicies } = useShippingPolicies();

  const shippingPolicy = shippingPolicies.data?.data.find(
    policy => policy.id === part.shippingPolicyId
  );

  if (shippingPolicies.isLoading) {
    return <LoadingPulse />;
  }

  if (!part.shippingPolicyId) {
    return <div className="italic text-gray-400">Not Set</div>;
  }

  return (
    <div>
      {shippingPolicy ? (
        <div>
          {shippingPolicy.name}{' '}
          <CourierPill courier={shippingPolicy.courier ?? ''} />
        </div>
      ) : (
        <div className="italic text-gray-400">Not Set</div>
      )}
    </div>
  );
}
